import JobsFilters from "./jobs-filters";

export default class Bookmarks {
    constructor(jobsFilters) {
        this.setupListeners();
        this.jobsFilters = jobsFilters;
    }

    setupListeners() {
        const that = this;
        $('#bookmarks').on('click', e => {
            if ($(e.target).is(':checked')) {
                this.jobsFilters.resetFilters(undefined, true);
                this.showBookmarks();
            } else {
                this.jobsFilters.applyFilters().then()
            }
        });

        $('body').on('click', '.bookmark-btn', function () {
            const jobId = $(this).attr('data-job-id')

            if ($(this).attr('data-bookmarked') === 'true') {
                that.removeBookmark(jobId, $(this));
            } else {
                that.addBookmark(jobId, $(this));
            }
        });

        window.addEventListener('jobs-loaded', function () {
            that.applyBookmarks();
        })
    }

    applyBookmarks() {
        let savedJobs = JSON.parse(localStorage.getItem('nm-jobs')) || [];

        for (const savedJob of savedJobs) {
            $(`.bookmark-btn[data-job-id="${savedJob}"]`)
                .addClass('active')
                .attr('data-bookmarked', 'true');
        }

    }

    showBookmarks() {
        let savedJobs = JSON.parse(localStorage.getItem('nm-jobs')) || [];

        this.jobsFilters.findJobs(savedJobs);
    }

    addBookmark(jobId, el) {
        const savedJobs = JSON.parse(localStorage.getItem('nm-jobs')) || [];

        if (! savedJobs.includes(jobId)) {
            savedJobs.push(jobId);
        }

        localStorage.setItem('nm-jobs', JSON.stringify(savedJobs));

        el.addClass('active')
            .attr('data-bookmarked', 'true');
    }

    removeBookmark(jobId, el) {
        let savedJobs = JSON.parse(localStorage.getItem('nm-jobs')) || [];

        if (savedJobs.includes(jobId)) {
            savedJobs = savedJobs.filter(savedJobId => savedJobId !== jobId);
        }

        localStorage.setItem('nm-jobs', JSON.stringify(savedJobs));

        el.removeClass('active')
            .attr('data-bookmarked', false);
    }
}
